import React from "react";

// Define the types for our component's props
type BookingMethod = "online" | "whatsapp";

interface BookingToggleProps {
    activeMethod: BookingMethod;
    onMethodChange: (method: BookingMethod) => void;
}

/**
 * A tab-like toggle component to switch between booking methods.
 */
const BookingToggle: React.FC<BookingToggleProps> = ({ activeMethod, onMethodChange }) => {
    // Base style for both buttons
    const baseStyle =
        "flex-1 py-3 px-4 text-center text-sm font-semibold rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2";

    // Style for the *active* button (blue)
    const activeStyle = "bg-blue-600 text-white shadow-md";

    // Style for the *inactive* button (gray)
    const inactiveStyle = "bg-gray-100 text-gray-700 hover:bg-gray-200";

    return (
        <div className="hidden md:flex w-full gap-1 max-w-md mx-auto p-1 bg-gray-200 rounded-lg">
            <button
                className={`${baseStyle} ${activeMethod === "online" ? activeStyle : inactiveStyle}`}
                onClick={() => onMethodChange("online")}
                aria-pressed={activeMethod === "online"}
            >
                Book Online
            </button>
            <button
                className={`${baseStyle} ${activeMethod === "whatsapp" ? activeStyle : inactiveStyle}`}
                onClick={() => onMethodChange("whatsapp")}
                aria-pressed={activeMethod === "whatsapp"}
            >
                Book on WhatsApp
            </button>
        </div>
    );
};

export default BookingToggle;
